const ErrorInfo = () => <h2>Sorry, error occured</h2>;

export default ErrorInfo;
